import type { ReactNode } from 'react'

export type ButtonVariant = 'principal' | 'secondaire' | 'discret' | 'danger'

interface ButtonProps {
  children: ReactNode
  onClick?: () => void
  variant?: ButtonVariant
  type?: 'button' | 'submit'
  disabled?: boolean
  pending?: boolean
  pendingLabel?: string
}

const VARIANTS: Record<ButtonVariant, string> = {
  principal: 'btn',
  secondaire: 'btn ghost',
  discret: 'btn ghost',
  danger: 'btn danger',
}

/**
 * Bouton.
 *
 * `pending` désactive ET change le libellé : un bouton qui reste cliquable pendant que la
 * requête part se fait cliquer deux fois, et deux transferts partent au lieu d'un.
 */
export function Button({
  children,
  onClick,
  variant = 'principal',
  type = 'button',
  disabled,
  pending,
  pendingLabel,
}: ButtonProps) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled === true || pending === true}
      aria-busy={pending === true}
      className={VARIANTS[variant]}
    >
      {pending === true && pendingLabel !== undefined ? pendingLabel : children}
    </button>
  )
}
